import React from 'react';
import Components from '../components/components';
import HelmetSEO from '../components/seo';
import { stripNode } from '../helpers/get-contents';

const SectionLandingPage = ({ data }) => {
    if (!data) {
        return <div>No data</div>;
    }
    const page = data.page.edges[0].node;
    const jobs = data.jobs ? data.jobs.edges : [];
    const insights = data.insights ? data.insights.edges : [];
    const regions = data.regions ? stripNode(data.regions.edges) : [];
    const locations = data.locations ? stripNode(data.locations.edges) : [];
    const subpageLayout = page.subpageLayout;

    let seo = {
        title: page.title,
        description: page.body,
        image: '',
    };
    page.extraModules.forEach(module => {
        if (module.__typename == 'DatoCmsMiniHero') {
            seo.image = module.image.sizes.src;
        }
    });
    return (
        <div>
            <HelmetSEO {...seo} />
            <div
                className={`section gray-dividers ${
                    subpageLayout == true ? 'indented-contents pt-60' : ''
                }`}>
                <Components
                    content={{
                        __typename: 'sidebysidetext',
                        title: page.title,
                        body: page.body,
                    }}
                />
                {page.extraModules &&
                    page.extraModules.map((module, i) => (
                        <Components
                            key={i}
                            content={module}
                            jobs={jobs}
                            insights={insights}
                            regions={regions}
                            locations={locations}
                            ignoreIndent={true}
                        />
                    ))}
            </div>
            <Components
                content={{
                    __typename: 'DatoCmsGiantLinkContainer',
                    links: page.links,
                }}
            />
        </div>
    );
};

export default SectionLandingPage;

export const SectionLandingPageQuery = graphql`
    query SectionLasdfndinerssdfssdfdfssdfddffdsdfsdfssdffssdsdffsdfddsfsdffertrtegPageQsdfsduery1sfsdf1(
        $slug: String!
    ) {
        page: allDatoCmsSectionLandingPage(filter: { slug: { eq: $slug } }) {
            edges {
                node {
                    pageName
                    slug
                    title
                    body
                    subpageLayout
                    extraModules {
                        __typename

                        ... on DatoCmsVideo {
                            video {
                                id
                                ...VideoFragment
                            }
                        }
                        ... on DatoCmsTraderProfile {
                            trader {
                                id
                                ...TraderFragment
                            }
                        }
                        ... on DatoCmsFactBar {
                            facts {
                                title
                                body
                            }
                        }
                        ... on DatoCmsMiniHero {
                            title
                            body
                            image {
                                ...HeroImageFragment
                            }
                        }
                        ... on DatoCmsMapForLandingpage {
                            title
                            map
                            citylist
                        }
                        ... on DatoCmsGreenLinkCollection {
                            links {
                                pageName
                                descriptionForLinks
                                iconForLinks {
                                    sizes(maxWidth: 50) {
                                        base64
                                        aspectRatio
                                        src
                                        srcSet
                                        sizes
                                    }
                                }
                                slug
                                parentPage {
                                    slug
                                }
                            }
                        }
                        ... on DatoCmsGreenFocusLinkCollection {
                            focusLink {
                                ctaText
                                shortDescription
                                title
                                link
                                linkToOpenInNewWindow
                            }
                        }
                        ... on DatoCmsFullWidthBanner {
                            bannerImageDesktop {
                                sizes(
                                    maxWidth: 1200
                                    imgixParams: { fm: "jpg", auto: "compress" }
                                ) {
                                    base64
                                    aspectRatio
                                    src
                                    srcSet
                                    sizes
                                }
                            }
                            bannerImageMobile {
                                sizes(
                                    maxWidth: 700
                                    imgixParams: { fm: "jpg", auto: "compress" }
                                ) {
                                    base64
                                    aspectRatio
                                    src
                                    srcSet
                                    sizes
                                }
                            }
                            link
                            linkToOpenInNewWindow
                        }
                        ... on DatoCmsJobList {
                            id
                        }
                        ... on DatoCmsText {
                            title
                            body
                        }
                    }
                    links {
                        id
                        ...GiantLinkFragment
                    }
                }
            }
        }
        insights: allDatoCmsInsightPage(sort: { fields: [date], order: DESC }) {
            edges {
                node {
                    ...InsightCardFragment
                }
            }
        }
        locations: allDatoCmsLocation(
            sort: { fields: [position], order: ASC }
        ) {
            edges {
                node {
                    ...LocationFragment
                }
            }
        }
        regions: allDatoCmsRegion(sort: { fields: [position], order: ASC }) {
            edges {
                node {
                    region
                    position
                }
            }
        }
    }
`;

// date(formatString: "MMMM DD, YYYY")



// WEBPACK FOOTER //
// ./src/templates/section-landingpage-template.js